import { getClientCityToCityByIdRequest } from "../../data/clientCityToCityApi";

function getResponseData(response) {
  return response?.data?.data || response?.data || null;
}

export async function getClientCityToCityByIdUseCase(id) {
  if (!id) {
    throw new Error("El id de la tarifa de ciudad es obligatorio.");
  }

  return getResponseData(await getClientCityToCityByIdRequest(id));
}
